import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiCalendar, FiClock } from "react-icons/fi";

export default function PendingApprovals() {

  const approvals = [

    {
      name: "Hendrita Merkel",
      img: "/assets/img/users/user-29-1.jpg",
      date: "Jan 10 - Jan 16",
      days: "4 days",
      reason: "Family trip"
    },

    {
      name: "Michael Brown",
      img: "/assets/img/users/user-27-1.jpg",
      date: "Jan 3 - Jan 9",
      days: "2 days",
      reason: "Medical appointment"
    },

    {
      name: "Daniel Martinez",
      img: "/assets/img/users/user-30-1.jpg",
      date: "Jan 17 - Jan 23",
      days: "2 days",
      reason: "Personal Work"
    }

  ];

  return (

    <Card className="shadow-sm border-0 pending-card">

      <Card.Body>

        {/* Header */}

        <div className="border rounded border-start border-start-primary d-flex align-items-center justify-content-between p-2 mb-3">

          <h5 className="mb-0 fw-semibold">
            Pending Approvals
          </h5>

          <Link to="/leave-page" className="btn btn-light btn-sm">
            View All
          </Link>

        </div>


        {/* Approval List */}

        {approvals.map((item, index) => (

          <div
            key={index}
            className="approval-item border rounded p-3 mb-2 d-flex flex-column flex-sm-row justify-content-between align-items-sm-center"
          >

            {/* Left Info */}

            <div>

              <div className="d-flex align-items-center mb-1">

                <img
                  src={item.img}
                  alt=""
                  width="38"
                  height="38"
                  className="rounded-circle me-2"
                />

                <span className="fw-semibold">
                  {item.name}
                </span>

              </div>

              <div className="text-muted small d-flex align-items-center flex-wrap">

                <span className="me-2 d-flex align-items-center">
                  <FiCalendar className="me-1"/>
                  {item.date}
                </span>

                <span className="mx-1">|</span>

                <span className="d-flex align-items-center">
                  <FiClock className="me-1"/>
                  {item.days}
                </span>

              </div>

              <div className="small mt-1 text-muted">
                Reason: {item.reason}
              </div>

            </div>


            {/* Buttons */}

            <div className="d-flex gap-2 mt-3 mt-sm-0">

              <Button className="btn-approve btn-sm">
                Approve
              </Button>

              <Button className="btn-decline btn-sm">
                Decline
              </Button>

            </div>

          </div>

        ))}

      </Card.Body>

      <style>

{
`.pending-card {
  border-radius: 10px;
}

.approval-item {
  background: #fff;
}

.btn-approve {
  background: #ff6b2c;
  border: none;
  color: white;
  padding: 6px 14px;
}

.btn-approve:hover {
  background: #ff6b2c;
}

.btn-decline {
  border: 1px solid #ff6b2c;
  color: #ff6b2c;
  background: white;
  padding: 6px 14px;
}

.btn-decline:hover {
  background: #fff3ee;
  color: #ff6b2c;
}

`


}
          
      </style>

    </Card>

  );

}